import { Action, createAction, createFeatureSelector, createReducer, createSelector, on, props } from '@ngrx/store';
import { EntityState } from '../../common/models/index';
import { UserAccount } from '../../session/models/index';

export class AccountState {
    public account: UserAccount;
    public state: EntityState;
    public error: any;
}

export const accountInitialState: AccountState = {
    account: null,
    state: EntityState.Progress,
    error: null
};

// ACTIONS
export enum AccountActionTypes {
    Read = '[ACCOUNT] Read',
    ReadSuccess = '[ACCOUNT] Read Success',
    ReadFailure = '[ACCOUNT] Read Failure',
    Update = '[ACCOUNT] Update',
    UpdateSuccess = '[ACCOUNT] Update Success',
    UpdateFailure = '[ACCOUNT] Update Failure',
}

export const accountReadAction = createAction(AccountActionTypes.Read);
export const accountReadSuccessAction = createAction(AccountActionTypes.ReadSuccess, props<{ account: UserAccount }>());
export const accountReadFailureAction = createAction(AccountActionTypes.ReadFailure, props<{ error: any }>());

export const accountUpdateAction = createAction(AccountActionTypes.Update, props<{ account: Partial<UserAccount> }>());
export const accountUpdateSuccessAction = createAction(AccountActionTypes.UpdateSuccess, props<{ account: UserAccount }>());
export const accountUpdateFailureAction = createAction(AccountActionTypes.UpdateFailure, props<{ error: any }>());

// SELECTORS

export const getAccountStoreState = createFeatureSelector<AccountState>('account');

export const getAccountData = createSelector(getAccountStoreState, (state: AccountState) => state.account);
export const getAccountState = createSelector(getAccountStoreState, (state: AccountState) => state.state);
export const getAccountError = createSelector(getAccountStoreState, (state: AccountState) => state.error);
export const getAccountPreferences = createSelector(getAccountStoreState, (state: AccountState) => state.account?.custom_dat);

// REDUCER

export const accountReducerFn = createReducer<AccountState>(
    accountInitialState,
    on(accountReadAction, (state) => ({ ...state, state: EntityState.Progress, error: null })),
    on(accountReadSuccessAction, (state, { account }) => ({ ...state, account, state: EntityState.Data, error: null })),
    on(accountReadFailureAction, (state, { error }) => ({ ...state, state: EntityState.Error, error })),

    on(accountUpdateAction, (state) => ({ ...state, state: EntityState.Progress, error: null })),
    on(accountUpdateSuccessAction, (state, { account }) => ({ ...state, account, state: EntityState.Data, error: null })),
    on(accountUpdateFailureAction, (state, { error }) => ({ ...state, state: EntityState.Error, error })),
);

export function accountReducer(state: AccountState | undefined, action: Action): AccountState {
    return accountReducerFn(state, action);
}
